import React from "react";
import { connect } from "react-redux";
import {
  noticeReducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./Notice.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import Notice from "../../library/Notice/Notice";
import { withRouter } from "react-router-dom";

export const SmartNotice = (props) => {
  const { accountUsername, closeModalGoHome, handleAcceptedTerms } = props;
  const email = props.match?.params.email;
  return (
    <Notice
      email={email}
      accountUsername={accountUsername}
      closeModalGoHome={closeModalGoHome}
      handleAcceptedTerms={handleAcceptedTerms}
    />
  );
};

export default dynamic(
  "noticeReducer",
  subspaced({
    mapExtraState: (state) => ({
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(noticeReducer)
)(connect(mapStateToProps, mapDispatchToProps)(withRouter(SmartNotice)));
